import React, {Component} from 'react';


import "./App.css";


class Freiheit extends Component {


	UNSAFE_componentWillMount(){
		window.scrollTo(0,0);
	}

render() {	
  return (	

	<div className="homeApp">
	<div className="contentHome">	
	
	<h2>Wirtschaft<br/>Finanzsystem</h2>
	<p>Bei diesem Thema ist die Zensur besonders hart gegen die Wahrheit vorgegangen.<br/>
	Ja, es geht wohl mehr um Geld, als um Gesundheit.</p>
	
		
		<div className="Ein">
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=8fLoEkXb7vY" target="_blank" >
			Die Flüchtlingskosten am Beispiel Berlin - der Weg in den Staatsbankrott 06.12.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=hHX1Jo9Pamg" target="_blank" >
			Video gesperrt: ZDF WISO Blackout in Deutschland - Horrorszenario oder reale Gefahr? 2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=E0cDIJdg9ac" target="_blank" >
			EZB-Insiderin gibt zu: E-Euro dient Überwachung 18.08.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=bk5oRMxzGOg" target="_blank" >
			Der Untergang des Euro mit Markus Krall | Mises Momente #9 02.08.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=sNUmOJ5_3UY" target="_blank" >
			Kann man die Kernkraftwerke in Deutschland wieder anschalten? -TE Wecker 30.07.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=is9KHr54Hx4" target="_blank" >
			Leider die brutale Wahrheit! | Immer mehr Deutsche verlassen das Land! 16.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=6kWqAAMxnVw" target="_blank" >
				Dr. Markus Krall erklärt, wie es in Deutschland weitergeht 03.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=d9gQ8QINW-I" target="_blank" >
			Das gefährlichste Experiment unseres Lebens (geht um alles) 24.04.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=b338yULxZMg&t=789s" target="_blank" >
			Markus Krall: Die Rückkehr der Bankenkrise (JF-TV Interview) 14 03 2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=GYZdPXERwvU" target="_blank" >
			TE Wecker am 23.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=GYZdPXERwvU" target="_blank" >
			TE Wecker am 23.03.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Smlbl6RLtU8" target="_blank" >
					Rettet unsere Industrie: Wirtschaft in Gefahr - Tichys Einblick Talk 27.01.2023
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=WV8iyq4jm10" target="_blank" >
			Tichys Ausblick: Null Energie – und dann alle pleite oder arbeitslos?  22.09.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=_Jkb0UwqGl4" target="_blank" >
			Bundespressekonferenz bestätigt Strommangel im Winter  11.09.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/sie-haben-alles-zerstoert-was-leistungsfaehige-buerger-dieses-landes-aufgebaut-haben/" target="_blank" >
			„Sie haben alles zerstört, was leistungsfähige Bürger dieses Landes aufgebaut haben“  18.09.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://report24.news/eu-preismechanismus-fuer-strom-fuehrt-europa-in-den-untergang-das-sind-die-hintergruende/?feed_id=21027" target="_blank" >
				EU-Preismechanismus für Strom führt Europa in den Untergang  28.08.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://deutsche-wirtschafts-nachrichten.de/521318/Kampf-gegen-das-Bargeld-Australien-testet-digitale-Waehrung?utm_source=FB_Ads&utm_medium=Artikel&utm_campaign=Interaktion_Kampagne1&fbclid=IwAR0eR5PQaTfSHYAdDEhS30mqV0jDEyS4LU0Vp9sazapWmuZLOf9POMEd5fk" target="_blank" >
			Kampf gegen das Bargeld: Australien testet digitale Währung  14.08.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://regelungstechnik.konradober.de/" target="_blank" >
						Wir sind im Exil  27.07.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Umowp0Jeaug"  target="_blank">
				Wer regiert die Welt? <strong>Der große Reset</strong> Die Durchführung, die Zusammenhänge - Ernst Wolff 24.05.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://auf1.tv/systemfehler-geldsystem-auf1/systemfehler-geldsystem-wer-regiert-die-welt/" target="_blank" >
				Systemfehler Geldsystem: Wer regiert die Welt? 17.04.2022	
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=c9-rG8q-fKk" target="_blank" >
			Auf der Zielgeraden zur Auflösung des Systems 31.03.2022	
			</a>
			<a className="videoText"  rel="noopener" href="https://odysee.com/@Punkt.PRERADOVIC:f/Wolff:f" target="_blank" >
			Ernst Wolff fasst zusammen wo wir stehen , zu ende hören Gefahr Transhumanismus 06.01.2022	
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=zj3CO5kXqGM" target="_blank" >
			"Wir stehen vor Umwälzungen, die sich niemand ausmalen kann!" Ernst Wolff über den Great Reset 15.12.2021	
			</a>			
			<a className="videoText"  rel="noopener" href="https://pressecop24.com/inflation-ist-politisch-gewollt-gold-experte-ueber-waehrungsverfall-und-weidmann-nachfolger/" target="_blank" >
			„Inflation ist politisch gewollt“ 01.11.2021	
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=oQwYhpbugcI" target="_blank" >
				JETZT SCHRILLEN ALLE ALARMGLOCKEN! 08.08.2021	
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=B90Gqls2hU8" target="_blank" >
				Es KOMMT in UNVORSTELLBAREM AUSMAß!<br/>Lass DICH NICHT TÄUSCHEN! 10.06.2021	
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=ZqzWzVjIJfs" target="_blank" >
				Jetzt tut es weh!<br/>Hans Werner Sinn 14.02.2021	
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=93jMDRs5NPU" target="_blank" >
				A. Popp - Sei vorbereitet!!! 08.04.2021
			</a>						
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=YCbcslfBR6Y" target="_blank" >
				Finanzsystem und Hartz IV-Regime	
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=QXHCtBTOM8s&t=5s" target="_blank" >
				GELD ENTWERTUNG VORBEREITET!<br/>Hans Werner Sinn 24.10.2020	
			</a>						
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=tQ5T8L0dG3Q" target="_blank" >
				Prof. Max Otte	11.10.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=w3L7vzPan7U" target="_blank" >
				Dr. Markus Krall	
			</a>
			<a className="videoText" rel="noopener"  href="https://www.bitchute.com/video/HOMRjO0xNJgZ/"  target="_blank">
				Die magische Virusrettung der Finanzelite?  06.01.2021
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=84qvIPGPkYQ" target="_blank" >
				Kritiker werden finanziell ausgeblutet<br/>04.01.2021	
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=YaPFoU-FWC8" target="_blank" >
				Ist es gesteuert?	
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=6lSJqjZ3vEI" target="_blank" >
				Andreas Popp	22.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=fVB7pGBtn1c" target="_blank" >
				Stefan Magnet	09.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=bT34HsltH-E" target="_blank" >
				Ernst Wolff	10.09.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=8W_ZSvaLhWk" target="_blank" >
				Andreas Popp   23.09.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=5ahXjGq2nv0" target="_blank" >
				Gerald Grosz   23.09.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=ygDoiJICtj0"  target="_blank">
						Amtseid der Kanzlerin
			</a>			
		</div>

	</div>

</div>
	 
  );
};
};

export default Freiheit;
